<template>
  <div
    :class="['soc-notice-panel']"
    :style="{ right: right + 'px', bottom: bottom + 'px' }"
  >
    <audio
      preload="auto"
      :id="'alarmAudio' + bottom"
      autoplay="autoplay"
      :src="alarmAudioUrl"
    ></audio>
    <!-- <iframe
      src=""
      frameborder="0"
      style="
        position: absolute;
        width: 330px;
        height: 150px;
        left: 0;
        top: 0;
        border: none;
        z-index: 1;
      "
    ></iframe> -->
    <i class="alarm-icon el-icon-warning"></i>
    <div class="alarm-content" v-if="info.key == 'FIREPATROLITEM_EXCEPTION_MESSAGE'">
      <h2 class="alarm-title">巡检项异常</h2>
      <p class="alarm-content-item">巡查名称：{{ info.deviceName }}</p>
      <p class="alarm-content-item">时间：{{ alarmTime }}</p>
    </div>

    <!-- 识别记录 -->
    <div class="alarm-content" v-if="info.key == 'MATCHRECORD'">
      <h2 class="alarm-title">识别详情</h2>
      <p class="alarm-content-item">
        类型：{{ matchType === 1 ? "人员识别" : "车辆识别" }}
      </p>
      <p class="alarm-content-item">位置：{{ areaName }}</p>
      <p class="alarm-content-item">时间：{{ matchTime | moment }}</p>
    </div>

    <!-- 告警类 -->
    <div class="alarm-content" v-if="alarmId && alarmType">
      <h2 class="alarm-title">
        {{ $t("base.title.notify") }}
      </h2>
      <p class="alarm-content-item">{{ $t("base.label.alarmName") }}：{{ deviceName }}</p>
      <p class="alarm-content-item">
        {{ $t("base.label.alarmLevel") }}：{{ alarmLevel | findByValue("SENU017") }}
      </p>
      <p class="alarm-content-item">
        {{ $t("base.label.alarmTime") }}：{{ alarmTime | moment }}
      </p>
    </div>

    <i @click="handleClose" class="el-icon-close close-icon"></i>
    <span @click.stop="getAlarmDetails" v-if="alarmId" class="detail-btn">{{
      $t("base.button.view")
    }}</span>
  </div>
  <!-- 识别中心 -->
</template>

<script>
import eventConfig from "@src/common/config/eventConfig";
import eventBus from "@src/common/utils/eventBus";
export default {
  name: "notice-panel",
  props: {
    matchType: {
      type: Number,
      default: -1,
    },
    commonAlarmType: {
      type: String,
      default: "",
    },
    areaName: {
      type: String,
      default: "",
    },
    matchRecordCode: {
      type: String,
      default: () => null,
    },
    matchTime: {
      type: String,
      default: "",
    },
    alarmTime: {
      type: [Number, String],
      default: 0,
    },
    deviceName: {
      type: String,
      default: "",
    },
    alarmType: {
      type: String,
      default: "",
    },
    right: {
      type: Number,
      default: -346,
    },
    bottom: {
      type: Number,
      default: 125,
    },
    alarmLevel: {
      type: Number,
      default: 1,
    },
    alarmAudioUrl: {
      type: String,
      default: "",
    },
    alarmId: {
      type: String,
      default: () => null,
    },
    subSystem: {
      type: String,
      default: () => null,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    keyObject: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      alarmName: "",
    };
  },
  methods: {
    // 告警级别样式变更
    handleLevelClass(val) {
      switch (val) {
        case "1":
          return "very-urgent";
        case "2":
          return "urgent";
        case "3":
          return "general";
        case "4":
          return "low";
      }
    },
    handleDesc() {
      this.$router.push({
        path: "/map/alarm/mapAlarm",
        query: { task: this.GenNonDuplicateID(3), alarmId: this.alarmId },
      });
    },
    GenNonDuplicateID(randomLength) {
      return Number(
        Math.random().toString().substr(3, randomLength) + Date.now()
      ).toString(36);
    },
    pauseAudio() {
      let audioName = "#alarmAudio" + this.bottom;
      var audio = document.querySelector(audioName);
      audio && audio.pause();
    },
    handleClose() {
      this.pauseAudio();
      this.$emit("closeMessage", this.matchRecordCode, this.keyObject);
    },
    getAlarmDetails() {
      this.pauseAudio();
      if (this.info.key == "FIREPATROLITEM_EXCEPTION_MESSAGE") {
        this.$router.push({
          path: "/firePatrol/count",
        });
        eventBus.emit(eventConfig.MENU_CLICK, { path: "/firePatrol/count" });
        return;
      }
      if (this.subSystem === "004" || this.subSystem === "013") {
        this.$router.push({
          path: "/fireAlarm",
          query: { alarmId: this.alarmId },
        });
        eventBus.emit(eventConfig.MENU_CLICK, { path: "/fireAlarm" });
      } else {
        this.$router.push({
          path: "/realTimeAlarm",
          query: { alarmId: this.alarmId },
        });
        eventBus.emit(eventConfig.MENU_CLICK, { path: "/realTimeAlarm" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alalrm-hidden {
  visibility: hidden;
}
.soc-notice-panel {
  position: fixed;
  width: 330px;
  height: 150px;
  z-index: 5;
  padding: 16px 10px;
  background: #23395e;
  .alarm-item {
    display: flex;
    position: relative;
    width: 330px;
    padding: 14px 26px 14px 13px;
    margin-bottom: 10px;
    box-sizing: border-box;
    border: 1px solid #596f94;
    background-color: #23395e;
  }
  .alarm-content {
    margin-left: 10px;
    margin-right: 8px;
    font-size: 14px;
    line-height: 21px;
    color: #c9d5ec;
  }
  .alarm-title {
    font-weight: bold;
    font-size: 16px;
    color: #e0ebff;
    margin: 0 0 5px 0;
  }
  .alarm-content-item {
    max-width: 255px;
    overflow: hidden;
    height: 25px;
    line-height: 25px;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  .detail-btn {
    border-color: transparent;
    color: #0086ff;
    background: transparent;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    z-index: 2;
    cursor: pointer;
  }
  .alarm-icon {
    height: 100%;
    width: 30px;
    float: left;
    font-size: 24px;
    color: #e6a23c;
  }
  .close-icon {
    position: absolute;
    top: 18px;
    right: 15px;
    cursor: pointer;
    color: #909399;
    z-index: 2;
    font-size: 16px;
    &:hover {
      color: #c9d5ec;
    }
  }
}
</style>
